import doRequest from '@/api/dssRequest';
import utility from '@/shared/utility';
import UserObject from '@/objects/UserObject';
import HomepageStructure from '@/objects/HomepageStructure';
import EventPreviousNextPromotion from '@/components/event/eventDetails/EventPreviousNextPromotion.vue';
import Event from '@/objects/Event';

const ChatBubble = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/chats/ChatBubble.vue'
  );
const EventSuggestions = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/homepage/EventSuggestions'
  );
const EventTemplateOne = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/homepage/eventTemplates/EventTemplateOne'
  );
const EventTemplateTwo = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/homepage/eventTemplates/EventTemplateTwo'
  );
const EventTemplateThree = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/homepage/eventTemplates/EventTemplateThree'
  );
const EventDetailsTickets = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/event/eventDetails/EventDetailsTickets'
  );
const EventDetailsProducts = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/event/eventDetails/EventDetailsProduct/EventDetailsProducts'
  );
const Booking = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/booking/Booking'
  );
const Booking_Details_Events = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/booking/Booking_Details_Events'
  );
const EventInstantProductDetails = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/event/eventDetails/EventInstantProductDetails'
  );
const EventDetails_Auction = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/event/eventDetails/EventDetailsAuction/EventDetails_Auction'
  );
const EventDetailsInfoReviews = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/event/eventDetails/EventDetailsInfoReviews'
  );
const SuccessDialog = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/generalComponents/uiComponents/SuccessDialog'
  );
const HomepageContainer = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/homepage/HomepageContainer'
  );

export default {
  components: {
    EventDetailsTickets,
    EventDetailsProducts,
    EventInstantProductDetails,
    Booking_Details_Events,
    Booking,
    EventSuggestions,
    ChatBubble,
    EventDetails_Auction,
    EventDetailsInfoReviews,
    EventTemplateOne,
    EventTemplateTwo,
    EventTemplateThree,
    SuccessDialog,
    HomepageContainer,
    EventPreviousNextPromotion,
  },
  computed: {
    showInfoUrl() {
      if (
        this.componentEventDetails.InfoUrl == null ||
        this.componentEventDetails.InfoUrl === ''
      ) {
        return false;
      }

      return true;
    },
    eventDetailsLoaded() {
      return (
        this.componentEventDetails != null &&
        Object.keys(this.componentEventDetails).length > 0
      );
    },
    suggestions() {
      let suggestionArray = [];

      // Add products
      if (this.componentEventDetails.SuggestionMap.Products != null) {
        const productSuggestions = [
          ...this.componentEventDetails.SuggestionMap.Products,
        ];
        const productsWithDiscount = [];
        const productsWithoutDiscount = [];
        productSuggestions.forEach((product) => {
          product.ObjectType = 'Product';

          if (product.Discount) {
            productsWithDiscount.push(product);
          } else {
            productsWithoutDiscount.push(product);
          }
        });

        suggestionArray = [
          ...suggestionArray,
          ...productsWithDiscount,
          ...productsWithoutDiscount,
        ];
      }

      // Add events
      if (this.componentEventDetails.SuggestionMap.Events != null) {
        const eventSuggestions = [
          ...this.componentEventDetails.SuggestionMap.Events,
        ];
        eventSuggestions.forEach((event) => {
          event.ObjectType = 'Event';
        });
        suggestionArray = [...suggestionArray, ...eventSuggestions];
      }

      return suggestionArray;
    },
    userId() {
      return this.$store.getters['auth/userObjectId'];
    },
    computedEventId() {
      return Event.getEventId(this.$route);
    },
    hasProducts() {
      return (
        this.isEventDetails &&
        (this.componentEventDetails.Type === 'OrderEvent' ||
          this.componentEventDetails.Type === 'Rental' ||
          this.componentEventDetails.Type === 'Webshop' ||
          this.componentEventDetails.Type === 'VirtualProductShop')
      );
    },
    isBookableEvent() {
      return (
        this.componentEventDetails.Type === 'Fixed' ||
        this.componentEventDetails.Type === 'FlexEvent' ||
        this.componentEventDetails.Type === 'Repetitive' ||
        this.componentEventDetails.Type === 'Tour'
      );
    },
    hasTickets() {
      return this.isEventDetails && this.isBookableEvent;
    },
    isAuction() {
      return this.componentEventDetails.Type === 'DutchAuction';
    },
    hasProductList() {
      return (
        this.currentComponent === 'instantProductDetails' &&
        (this.componentEventDetails.Type === 'OrderEvent' ||
          this.componentEventDetails.Type === 'Rental' ||
          this.componentEventDetails.Type === 'Webshop' ||
          this.componentEventDetails.Type === 'VirtualProductShop')
      );
    },
    hasSuggetions() {
      if (this.componentEventDetails.SuggestionMap != null) {
        if (
          this.componentEventDetails.SuggestionMap.Events != null &&
          this.componentEventDetails.SuggestionMap.Events.length > 0
        ) {
          // Has event suggestions
          return true;
        }

        if (
          this.componentEventDetails.SuggestionMap.Products != null &&
          this.componentEventDetails.SuggestionMap.Products.length > 0
        ) {
          // Has product suggestions
          return true;
        }
      }

      // No suggestions
      return false;
    },
    reviewAllowed() {
      if (this.hasProductList) {
        return false;
      }
      if (
        this.$store.getters.getCurrentDetailsForEventPage.Type ===
        'ProductCategory'
      ) {
        return false;
      }
      if (this.componentEventDetails.Bookable) {
        if (
          this.componentEventDetails.Type === 'Webshop' ||
          this.componentEventDetails.Type === 'DutchAuction' ||
          this.componentEventDetails.Type === 'VirtualProductShop'
        ) {
          return true;
        }
        return false;
      }
      return true;
    },
    showImage() {
      return (
        this.isEventDetails ||
        this.currentComponent === 'instantProductDetails' ||
        this.currentComponent === 'Booking_Details_Events'
      );
    },
    showVideo() {
      return (
        (this.isEventDetails ||
          this.currentComponent === 'instantProductDetails') &&
        this.componentEventDetails.VideoUrl !== ''
      );
    },
    btnSize() {
      // Dynamic size of buttons to fit different screen sizes
      const size = {
        xs: 'x-small',
        sm: 'small',
        lg: 'large',
        xl: 'x-large',
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
    initialized() {
      if (this.eventDetailsInitialized) return true;
      return false;
    },
    userLoggedIn() {
      return this.$store.getters['auth/userName'];
    },
    videoMaxHeight() {
      return `max-height: ${
        this.$vuetify.breakpoint.smAndDown ? '50vh' : '60vh'
      }`;
    },
    showSubscriptionBtn() {
      if (
        this.componentEventDetails != null &&
        this.componentEventDetails.ShowSubscriptionButton
      ) {
        return true;
      }
      return false;
    },
    partnerGroupDetails() {
      return this.$store.getters['Account/partnerGroupDetails'];
    },
    mainPartner() {
      if (
        this.partnerGroupDetails == null ||
        this.partnerGroupDetails.Partners == null
      ) {
        return {};
      }

      const result = this.partnerGroupDetails.Partners.find(
        (partner) => partner.MainPartner
      );

      if (result == null) {
        return {};
      }

      return result;
    },
    isEventDetails() {
      return this.currentComponent === 'Details';
    },
    isPromotion() {
      return (
        this.componentEventDetails.Type === 'Promotion' ||
        this.componentEventDetails.Type === 'RepeatingPromotion'
      );
    },
    isPromotionOrBlog() {
      return (
        this.componentEventDetails.Type === 'Promotion' ||
        this.componentEventDetails.Type === 'RepeatingPromotion' ||
        this.componentEventDetails.Type === 'BlogEvent'
      );
    },
    isPromotionDetails() {
      return this.isEventDetails && this.isPromotionOrBlog;
    },
    isQuizEvent() {
      return this.componentEventDetails.Type === 'Quiz';
    },
    productFocused() {
      if (
        this.partnerGroupDetails == null ||
        this.partnerGroupDetails.Focus == null
      ) {
        return true;
      }

      if (this.partnerGroupDetails.Focus === 'Product') {
        return true;
      }

      return false;
    },
    homepageStructure() {
      return new HomepageStructure(
        this.$store.getters.getFrontEndType,
        this.productFocused
      );
    },
    mdAndUp() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    imgPosition() {
      // Align promotion image to the top to prevend people's head from being cut
      if (this.isPromotionOrBlog) {
        return '50% 10%';
      }
      return 'center';
    },
    bannerHeight() {
      let height = window.innerWidth * 0.618;
      const maxHeight = window.innerHeight * 0.6;
      if (height > maxHeight) {
        height = maxHeight;
      }
      return height;
    },
  },
  watch: {
    eventDetailsLoaded() {
      if (this.eventDetailsLoaded) {
        this.scrollToProperPosition();
      }
    },
  },
  data() {
    return {
      hidePromotionBox: true,
      // chats
      chatDialogOpen: false,
      defaultCategories: [],
      selectedChat: {},

      // to change eventDetails to categoryDetails
      bigPicture: '',
      description: '',
      translatedName: '',

      componentEventDetails: {},
      rentalData: [],
      favourites: [],
      currentComponent: '',
      eventPictures: [],
      scrolled: 0,
      fullDescription: false,
      showButtons: true,

      // special request
      specialRequestError: false,
      toggleAddSpecialRequest: false,
      specialRequestText: '',
      successDialog: false,
      paymentMsg: '',

      // User subscriptions
      possibleSubscriptions: [],
      addUserToSubscriptionsDialog: false,

      // Partner reviews
      reviewDialog: false,
      review: '',
      reviewError: false,
      rating: {},
    };
  },
  created() {
    window.EventBus.listen('reserve', this.reserve);
    window.EventBus.listen('rentalFlowReserve', this.rentalFlowReserve);
    window.EventBus.listen('setCurrentComponent', this.setCurrentComponent);
    // change eventDetails
    window.EventBus.listen('setEventDetailsView', this.setEventDetailsView);
  },
  mounted() {
    // Scroll to top on mounted
    window.scrollTo(0, 0);

    this.updateTmpUserFromURL();

    this.componentEventDetails = this.eventDetails;
    this.getFavourites();
    this.init();
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      'setEventDetailsView',
      this.setEventDetailsView
    );
    window.EventBus.removeListener('reserve', this.reserve);
    window.EventBus.removeListener('rentalFlowReserve', this.rentalFlowReserve);
    window.EventBus.removeListener(
      'setCurrentComponent',
      this.setCurrentComponent
    );
  },
  methods: {
    scrollToReviews() {
      const element = document.getElementById('reviewSection');
      const headerOffset = 56;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    },
    goToAccount() {
      this.reviewDialog = false;
      this.$router.push({
        name: 'UserSettings',
      });
    },
    getSubscriptionText() {
      let textForSubs = '';
      for (let i = 0; i < this.possibleSubscriptions.length; i++) {
        // check if it is the last subscription than don't use the space and comma
        if (i + 1 === this.possibleSubscriptions.length) {
          textForSubs += `'${this.possibleSubscriptions[i].Name}'`;
        } else {
          textForSubs += `'${this.possibleSubscriptions[i].Name}', `;
        }
      }
      return this.$translate('SUBSCRIPTION_TEXT').replace(
        '(recepten)',
        textForSubs
      );
    },
    checkIfSubscriptionIsNotInList() {
      const availableSubscriptionsArray = [];
      if (
        this.componentEventDetails.hasOwnProperty('CohortIdsForSubscription')
      ) {
        this.componentEventDetails.CohortIdsForSubscription.forEach((sub) => {
          this.$store.getters['auth/subscriptions'].forEach((userSubs) => {
            if (
              userSubs.CohortId === sub &&
              userSubs.CommunicationState !== 0
            ) {
              availableSubscriptionsArray.push(sub);
            }
          });
        });
      }
      if (availableSubscriptionsArray.length !== 0) {
        this.hidePromotionBox = false;
      }
    },
    setEventDetailsView() {
      if (Object.keys(this.componentEventDetails).length) {
        this.$store.commit('setCurrentDetailsForEventPage', {
          Type: 'Event',
          Id: this.componentEventDetails.EventId,
          Description: this.componentEventDetails.Description.replace(
            /\n/g,
            '<br>'
          ),
          Name: this.componentEventDetails.EventTranslationName,
          Picture: this.eventPictures[0],
          Video: this.componentEventDetails.VideoUrl !== '' ? this.componentEventDetails.VideoUrl : '',
          PortraitVideo: this.componentEventDetails.PortraitVideoUrl !== '' ? this.componentEventDetails.PortraitVideoUrl : '',
          PortraitPicture: this.componentEventDetails.PortraitPictureUrl !== '' ? this.componentEventDetails.PortraitPictureUrl : '',
        });
      } else {
        this.getEventDetails();
      }
    },
    rentalFlowReserve(cartProduct) {
      this.rentalData = cartProduct;
      this.getCurrentComponent('Booking_Details_Events');
    },
    reserve(cartProduct) {
      this.$store.commit('shoppingCart/addOrder', cartProduct);
    },
    setCurrentComponent(receivedData) {
      this.currentComponent = receivedData.component;
      if (receivedData.redirect != null) {
        this.init();
      }
    },
    init() {
      if (
        this.$route.params.event_id != null &&
        this.$route.params.event_id > 0
      ) {
        this.$store.commit(
          'event/setCurrentEventId',
          this.$route.params.event_id
        );
      }

      if (this.$route.params.product_id != null) {
        this.$store.commit(
          'event/setCurrentProductId',
          this.$route.params.product_id
        );
      }

      this.getEventDetails();
      // check if the block for subscription should be hide
      setTimeout(() => {
        this.checkIfSubscriptionIsNotInList();
      }, 1000);
    },
    onScroll(e) {
      // console.log("we scrolled: ", e.target.scrollingElement.scrollTop);
      this.scrolled = e.target.scrollingElement.scrollTop;
    },
    setEventPicture(image) {
      // getting the data from category.js or image for cache clearing
      this.bigPicture =
        this.$store.getters['category/categoryDetails'].PictureUrl || image;
    },
    setEventName(name) {
      this.translatedName =
        this.$store.getters['category/categoryDetails'].Name || name;
    },
    setDescription(description) {
      // show the full description and replace the \n with <br> tags
      this.description = description.replace(/\n/g, '<br>');
    },
    eventDetailBack() {
      if (this.currentComponent === 'Details') {
        this.$router.go(-1);
      } else {
        this.getCurrentComponent('Details');
      }
    },
    goHome() {
      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
    goToMyActivities() {
      this.$router.push({
        name: 'UserSettings',
        params: { myOrders: true },
      });
    },
    getSourceKeyFromURL() {
      // get the url
      const url_string = window.location.href;
      const url = new URL(url_string);
      // find the SourceKey paramater and read the value
      const sourceKey = url.searchParams.get('SourceKey');

      // if sourceKey is not available set an empty string
      return sourceKey || '';
    },
    updateTmpUserFromURL() {
      // If user is not logged in and url contains user, update tmp user id
      const user = this.$route.query.User;
      if (user != null && user.trim() !== '' && user !== '${USER_ID}') {
        const userLoggedIn = this.$store.getters['auth/isValid'];
        if (!userLoggedIn) {
          this.$store.commit('auth/setTmpUserId', user);
        }
      }
    },
    getEventDetails() {
      // Initialize event info
      this.componentEventDetails = {};
      this.eventPictures = [];

      // get the source key from the url
      const sourceKey = this.getSourceKeyFromURL();

      const payload = {
        SourceKey: sourceKey,
        UseGenericResponse: false,
        EventId: this.computedEventId,
      };

      doRequest(
        (response) => {
          this.componentEventDetails = response.data;

          // update metaData
          if (this.componentEventDetails.MetaData != null) {
            window.EventBus.fire(
              'updateMetaData',
              this.componentEventDetails.MetaData
            );
          }

          // Save all pictures in one container
          this.eventPictures.push(this.componentEventDetails.PictureUrl);
          if (
            Object.values(this.componentEventDetails.ExtraPictures).length > 0
          ) {
            Object.values(this.componentEventDetails.ExtraPictures).forEach(
              (img) => this.eventPictures.push(img)
            );
          }

          // to set the eventCurrentDetails
          this.$store.commit('setCurrentDetailsForEventPage', {});
          this.$store.commit('setCurrentDetailsForEventPage', {
            Type: 'Event',
            Id: this.componentEventDetails.EventId,
            Description: this.componentEventDetails.Description.replace(
              /\n/g,
              '<br>'
            ),
            Name: this.componentEventDetails.EventTranslationName,
            Picture: this.eventPictures[0],
            Video: this.componentEventDetails.VideoUrl !== '' ? this.componentEventDetails.VideoUrl : '',
            PortraitVideo: this.componentEventDetails.PortraitVideoUrl !== '' ? this.componentEventDetails.PortraitVideoUrl : '',
            PortraitPicture: this.componentEventDetails.PortraitPictureUrl !== '' ? this.componentEventDetails.PortraitPictureUrl : '',
          });

          if (this.isBookableEvent) {
            this.getCurrentComponent('Booking_Details_Events');
          } else {
            this.getCurrentComponent('Details');
          }
          this.eventDetailsInitialized = true;
          if (this.$store.getters['event/currentProductId'] !== '') {
            this.getCurrentComponent('instantProductDetails');
          }

          this.getMessagesForUser(this.mainPartner, true);
        },
        () => {
          this.goHome();
        },
        'getEventDetails',
        this.userId,
        payload,
        'GET'
      );
    },
    getMessagesForUser(partner, closed = false) {
      // return from this function if user is not logged in
      if (this.$store.getters['auth/userName'] === '') {
        return;
      }
      // Get all the default chat messages and categories from the MessageSearchEngine
      const payload = {
        FilterPeerId: `${partner.AccountId}_UG_${partner.PartnerId}`,
      };
      doRequest(
        (response) => {
          this.selectedChat = {};
          response.data.Messages.forEach((chat) => {
            if (
              chat.PeerId === `${partner.AccountId}_UG_${partner.PartnerId}`
            ) {
              this.selectedChat = chat;
            }
          });
          if (!closed) {
            this.chatDialogOpen = true;
            this.markMessagesAsRead(partner);
          }
        },
        () => {},
        'getMessagesForUser',
        'LocationsNode_MSE',
        payload
      );
    },
    markMessagesAsRead(partner) {
      // Mark all messages within the chat as read
      const payload = {};

      doRequest(
        () => {
          this.selectedChat.Messages.forEach((message) => {
            if (message.PeerUserId !== '' && !message.Read) {
              message.Read = true;
            }
          });
          this.selectedChat.UnreadMessages = 0;
        },
        () => {},
        'markMessageAsRead',
        `${partner.AccountId}_UG_${partner.PartnerId}`,
        payload
      );
    },
    getDefaultChatMessagesAndCategories(partner) {
      // Check if user is logged in
      if (this.$store.getters['auth/userName'] === '') {
        window.EventBus.fire('triggerOpenAccountFromMenu', {
          toggle: true,
          component: 'Login',
        });
        return;
      }
      // Get all the default chat messages and categories from the MessageSearchEngine
      const payload = {
        PartnerId: partner.PartnerId,
      };

      doRequest(
        (response) => {
          this.defaultCategories = [];
          this.defaultCategories = response.data.Categories;
          this.getMessagesForUser(partner);
        },
        () => {},
        'getDefaultChatMessagesAndCategories',
        'LocationsNode_MSE',
        payload
      );
    },
    openYoutube(url) {
      const fullUrl = utility.getFullUrl(url);
      window.open(fullUrl);
    },
    toggleFavourite() {
      // Check if user is logged in
      if (this.$store.getters['auth/userName'] === '') {
        window.EventBus.fire('triggerOpenAccountFromMenu', {
          toggle: true,
          component: 'Register',
        });
        return;
      }
      const favCheck = this.favourites.some(
        (fav) => fav.Id === this.$store.getters.getCurrentDetailsForEventPage.Id
      );
      console.log('Brian favCheck', favCheck);
      if (favCheck) {
        this.deleteFavourite();
      } else {
        this.addFavourite();
        if (
          this.$store.getters.getCurrentDetailsForEventPage.Type === 'Event'
        ) {
          this.checkUserSubscriptions(this.componentEventDetails);
        }
      }
    },
    checkUserSubscriptions(event) {
      if (event.hasOwnProperty('CohortIdsForSubscription')) {
        const userSubscriptions = this.$store.getters['auth/subscriptions'];
        this.possibleSubscriptions = [];
        event.CohortIdsForSubscription.forEach((sub) => {
          userSubscriptions.forEach((userSubs) => {
            if (
              userSubs.CohortId === sub &&
              userSubs.CommunicationState !== 0
            ) {
              if (userSubs.SubscribeByUser) {
                switch (userSubs.CommunicationState) {
                  case -1:
                    this.possibleSubscriptions.push({
                      ...userSubs,
                      MailSwitch: false,
                      PushSwitch: false,
                    });
                    break;
                  case 1:
                    this.possibleSubscriptions.push({
                      ...userSubs,
                      MailSwitch: false,
                      PushSwitch: true,
                    });
                    break;
                  case 2:
                    this.possibleSubscriptions.push({
                      ...userSubs,
                      MailSwitch: true,
                      PushSwitch: false,
                    });
                    break;
                  default:
                    break;
                }
              }
            }
          });
        });
        if (this.possibleSubscriptions.length > 0) {
          this.addUserToSubscriptionsDialog = true;
        }
      }
    },
    changeSubscriptions() {
      const payload = {
        Subscriptions: [],
      };
      this.possibleSubscriptions.forEach((subs) => {
        if (subs.MailSwitch && subs.PushSwitch) {
          subs.CommunicationState = 0;
          delete subs.MailSwitch;
          delete subs.PushSwitch;
        } else if (subs.MailSwitch && !subs.PushSwitch) {
          subs.CommunicationState = 2;
          delete subs.MailSwitch;
          delete subs.PushSwitch;
        } else if (!subs.MailSwitch && subs.PushSwitch) {
          subs.CommunicationState = 1;
          delete subs.MailSwitch;
          delete subs.PushSwitch;
        } else {
          subs.CommunicationState = -1;
          delete subs.MailSwitch;
          delete subs.PushSwitch;
        }
        payload.Subscriptions.push({
          CohortId: subs.CohortId,
          CommState: subs.CommunicationState,
        });
      });
      doRequest(
        () => {
          this.$store.commit('auth/setSubscriptions', []);
          this.$store.commit(
            'auth/setSubscriptions',
            this.possibleSubscriptions
          );
          this.possibleSubscriptions = [];
          this.addUserToSubscriptionsDialog = false;
        },
        () => {},
        'changeSubscriptions',
        this.$store.getters['auth/userName'],
        payload
      );
    },
    isEventAFavourite() {
      // Set the icon based on user favourites
      if (this.$store.getters.getCurrentDetailsForEventPage.Type === 'Event') {
        if (
          typeof this.$store.getters.getCurrentDetailsForEventPage.Id ===
          'number'
        ) {
          this.$store.getters.getCurrentDetailsForEventPage.Id =
            this.$store.getters.getCurrentDetailsForEventPage.Id.toString();
        }
      }

      const returnState = this.favourites.some(
        (fav) => fav.Id === this.$store.getters.getCurrentDetailsForEventPage.Id
      );
      if (returnState) return 'favorite';
      return 'favorite_border';
    },
    addSpecialRequestToReservation() {
      if (this.specialRequestText === '') {
        return;
      }
      if (this.$store.getters['auth/userName'] === '') {
        return;
      }
      this.specialRequestError = true;
      const payload = {
        OrderId: '',
        OrderItemId: '',
        SpecialRequest: this.specialRequestText,
      };
      doRequest(
        (response) => {
          window.EventBus.fire(
            'activateSnackBar',
            this.$translate('SPECIAL_REQUEST_SEND')
          );
          this.specialRequestText = '';
          const toStoreOrder = response.data;
          toStoreOrder.ShoppingCartType = 'SpecialRequest';
          this.bookWithReservations(toStoreOrder);
        },
        (error) => {
          if (error.data.ErrorCode === 'E_PO_24') {
            window.EventBus.fire(
              'activateErrorDialog',
              this.$translate('E_PO_024_ADDSPECIALREQUEST')
            );
          } else {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('FAILED_ADDING_SPECIAL_REQUEST')
            );
          }
        },
        'addSpecialRequestToReservation',
        this.$store.getters['event/currentEventId'],
        payload
      );
    },
    bookWithReservations(specialRequest) {
      const payload = {
        OnlySpecialRequests: true,
        IgnoreUserPlanBoard: true,
        UserInfo: this.$store.getters['auth/user'],
        Note: '',
      };

      payload.Reservations = {};
      payload.Reservations[specialRequest.EventInfo.EventId] = [
        specialRequest.MainOrder.OrderId,
      ];
      const objectId = this.$store.getters['auth/userName'];
      doRequest(
        (response) => {
          switch (response.data.Status) {
            case 'PartnerConfirmation':
              // Need to wait for partner's response
              console.log('Order needs to be confirmed by partner');
              this.successDialog = true;
              this.paymentMsg = this.$translate(
                'ORDER_WAIT_FOR_PARTNER_CONFIRMATION'
              );
              break;
            case 'Confirmed':
              // Order confirmed by payment method of DirectDebit or free of charge
              console.log('Order already been confirmed');
              if (
                response.data.PaymentMessage != null &&
                response.data.PaymentMessage.trim() !== ''
              ) {
                this.paymentMsg = response.data.PaymentMessage;
              } else {
                this.paymentMsg = this.$translate('ORDER_COMPLETED_DEFAULT');
              }
              this.successDialog = true;
              break;
            case 'WaitingForPayment':
              // Waiting for payment, redirect to mollie
              console.log('Order waiting for payment');
              if (
                response.data.PaymentUrl != null &&
                response.data.PaymentUrl.trim() !== ''
              ) {
                window.location.href = response.data.PaymentUrl;
              } else {
                window.EventBus.fire(
                  'activateSnackBar',
                  this.$translate('BOOKING_FAIL')
                );
              }
              break;
            default:
              console.log('Unknown order status: ', response.data.Status);
              this.paymentMsg = this.$translate('ORDER_COMPLETED_DEFAULT');
              this.successDialog = true;
              break;
          }

          this.specialRequestError = false;
          this.toggleAddSpecialRequest = false;
        },
        (error) => {
          if (error.data.ErrorCode === 'E_PO_023') {
            window.EventBus.fire(
              'activateErrorDialog',
              this.$translate('E_PO_023_BOOKWITHRESERVATIONS'),
              false
            );
          } else {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('FAILED_BOOKING_SPECIAL_REQUEST')
            );
          }
        },
        'bookWithReservations',
        objectId,
        payload,
        'POST',
        600000,
        false
      );
    },
    addFavourite() {
      const pageDetails = this.$store.getters.getCurrentDetailsForEventPage;

      UserObject.addFavourite(pageDetails.Id, pageDetails.Type).then(() => {
        this.favourites.push(pageDetails);

        if (
          (this.componentEventDetails.Type === 'Promotion' ||
            this.componentEventDetails.Type === 'RepeatingPromotion') &&
          this.componentEventDetails.CohortIdsForSubscription.length !== 0 &&
          this.$store.getters['auth/userName'] !== '' &&
          !this.hidePromotionBox
        ) {
          // user could register for cohort
          this.checkUserSubscriptions(this.componentEventDetails);
        }
      });
    },
    deleteFavourite() {
      const pageDetails = this.$store.getters.getCurrentDetailsForEventPage;

      UserObject.deleteFavourite(pageDetails.Id, pageDetails.Type).then(() => {
        this.favourites = this.favourites.filter(
          (fav) => fav.Id !== pageDetails.Id
        );
      });
    },
    getFavourites() {
      UserObject.getFavourites()
        .then((response) => {
          this.favourites = [];

          Object.entries(response.data.FavouriteMap).forEach(
            ([groupType, group]) => {
              if (groupType !== 'Products') {
                group.forEach((favouriteItem) => {
                  // eslint-disable-next-line no-param-reassign
                  favouriteItem.Type = groupType;

                  if (groupType === 'Events') {
                    // eslint-disable-next-line no-param-reassign
                    favouriteItem.Id = favouriteItem.EventId;
                  }

                  this.favourites.push(favouriteItem);
                });
              }
            }
          );

          this.favourites = this.favourites.reverse();
        })
        .catch(() => {});
    },
    bookProducts(products, specialRequests) {
      this.componentEventDetails.shoppingCart = products;
      this.componentEventDetails.specialRequests = specialRequests;
      // if it is a rental you have to send some props
      if (this.componentEventDetails.Type === 'Rental') {
        this.rentalData = products;
      }
      this.currentComponent = 'Booking';
    },
    /** returns the component name for in HTML * */
    getCurrentComponent(receivingData) {
      this.currentComponent = receivingData;
    },
    onCreateSubscription() {
      this.$router.push({
        name: 'EventSubscription',
        params: {
          event_id: this.componentEventDetails.EventId,
        },
      });
    },
    isYoutubeVideo(url) {
      if (
        this.componentEventDetails.InfoUrl == null ||
        this.componentEventDetails.InfoUrl === ''
      ) {
        return false;
      }

      const regex = /youtube\./g;
      const result = url.match(regex);

      if (result != null) return true;
      return false;
    },
    getYoutubeVideoId(url) {
      const regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : '';
    },
    scrollToProperPosition() {
      // Mainly used for promotion event to show part of the image and let content visible
      if (this.isPromotionOrBlog) {
        const scrollY = this.bannerHeight * 0.33;
        window.scroll({ top: scrollY, left: 0, behavior: 'smooth' });
      }
    },
    joinQuiz() {
      console.log('Going to join the quiz ...');
      this.$router.push({
        name: 'QuizQuestions',
        params: {
          eventDetails: this.componentEventDetails,
        },
      });
    },
  },
};
